<template>
    <section>
        <h1>Users</h1>
        <section>
            <h2>Create user</h2>
            <section class="input-grid">
                <h2>Name</h2>
                <input v-model="name"  v-on:keyup.enter="login" type="text"/>
                <div></div>
            </section>
            <section class="input-grid">
                <h2>Email</h2>
                <input v-model="email"  v-on:keyup.enter="login" type="text"/>
                <div></div>
            </section>
            <section class="input-grid">
                <h2>Password</h2>
                <input v-model="password"  v-on:keyup.enter="login" type="text"/>
                <div></div>
            </section>
            <button v-on:click="login">Create User</button>
        </section>
    </section>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "Users",
        data(){
            return {
                email: null,
                password: null,
                name: null
            }
        },
        methods: {
            login(){
                if(this.email === null){
                    return;
                }

                if(this.password === null){
                    return;
                }

                if(this.name === null){
                    return;
                }

                axios
                    .post(process.env.VUE_APP_HOST_ADRES + '/user', {
                        email: this.email,
                        password: this.password,
                        name: this.name
                    },
                    {
                        headers: {
                            Authorization: 'Bearer ' + localStorage.getItem('user-token'),
                        }
                    })
                    .then(response => {

                        console.log(response)
                    })
            }
        }
    }
</script>

<style scoped lang="scss">
</style>